const styles: any = {
  contentSummary: {
    textAlign: "center",
  },
  bold: { fontWeight: "bold" },
  contentMain: {
    height: "100%",
    position: "relative",
    overflow: "auto",
  },
  contentFooterRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: 'column'
  },
  contentFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "20vh",
  },
  contentFit: {
    height: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    height: "100vh",
  },
  containerProducts: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  listItems: {
    overflow: "auto",
  },
};

export default styles;
